/**
 * Resolves a channel identifier to the MongoDB ObjectId string of the matching
 * entry in team.salesChannels[].
 *
 * @param {string} channelId - salesChannelId, store name, or legacy type ("shopify")
 * @param {Array} salesChannels - team.salesChannels array
 * @returns {string} ObjectId string or original channelId
 */
const resolveSalesChannelId = (channelId, salesChannels = []) => {
  if (!channelId) return channelId;

  const normalizedChannelId = String(channelId);

  const byId = salesChannels.find(
    (salesChannel) => String(salesChannel._id) === normalizedChannelId,
  );
  if (byId) return String(byId._id);

  const byName = salesChannels.find(
    (salesChannel) => salesChannel.name === normalizedChannelId,
  );
  if (byName) return String(byName._id);

  const byType = salesChannels.find(
    (salesChannel) => salesChannel.type === normalizedChannelId,
  );
  if (byType) return String(byType._id);

  return normalizedChannelId;
};

export default resolveSalesChannelId;
